import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    if (error?.message?.includes('dynamically imported module')) {
      console.warn('Chunk load failed – reloading app');
      window.location.reload();
      return;
    }

    // Logga övriga fel
    /* console.error(error); */
  }
}
